// extracted by mini-css-extract-plugin
export default {"container":"pills-list_container__WgCSH","item":"pills-list_item__d58dt"};